import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getUserSubscription } from '../services/subscription';
import { Clock, Zap } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/trialBanner.module.css';

const TrialBanner = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [subscription, setSubscription] = useState(null);
  const [daysLeft, setDaysLeft] = useState(0);

  useEffect(() => {
    const fetchSubscription = async () => {
      if (user) {
        const sub = await getUserSubscription(user.id);
        setSubscription(sub);

        if (sub && sub.status === 'trialing' && sub.trial_end) {
          const trialEnd = new Date(sub.trial_end);
          const now = new Date();
          const diffTime = trialEnd - now;
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          setDaysLeft(diffDays);
        }
      }
    };

    fetchSubscription();
  }, [user]);

  // Only show if user is in trial
  if (!subscription || subscription.status !== 'trialing') {
    return null;
  }

  const handleUpgrade = () => {
    navigate('/pricing');
  };

  return (
    <div className={styles.trialBanner}>
      <div className={styles.content}>
        <Clock size={20} />
        <span>
          {daysLeft > 1 ? (
            <>
              <strong>{daysLeft} days left</strong> in your free trial
            </>
          ) : daysLeft === 1 ? (
            <>
              <strong>1 day left</strong> in your free trial
            </>
          ) : (
            <>
              Your trial ends <strong>today</strong>
            </>
          )}
        </span>
      </div>
      <button className={styles.upgradeBtn} onClick={handleUpgrade}>
        <Zap size={16} />
        Upgrade Now
      </button>
    </div>
  );
};

export default TrialBanner;
